export default __webpack_public_path__ + "static/media/alte_goetter_cover.5cee3716.webp";